import React from "react";

interface ButtonProps extends React.PropsWithChildren {
    className?: string;
    onClick?: () => void;
    isDisabled?: boolean;
    textStyle?: string;
    form?: string;
    type?: "button" | "submit";
    testid?: string;
}

const Button: React.FC<ButtonProps> = ({
    children,
    onClick,
    className = "",
    isDisabled = false,
    textStyle = "",
    type = "button",
    form,
    testid = ""
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={isDisabled}
            form={form}
            className={className}
            data-testid={testid}
        >
            <div className="flex items-center justify-center">
                <span
                    className={textStyle}
                >
                    {children}
                </span>
            </div>
        </button>
    );
};

export default Button;
